'use client';

import RiveAnimation from '@/components/atoms/rive-animation/rive-animation';

type BrandTag = TravelPortal.Components['TravelPortalOffer']['brandTag'];

const BRAND_TAG_ANIMATION_MAP: Partial<Record<BrandTag, RiveAnimationName>> = {
  AarhusCharterDK: 'ProviderAarhuscharter',
  BravoToursDK: 'ProviderBravotours',
  DanskiDK: 'ProviderDanski',
  NortlanderDK: 'ProviderNortlander',
  NortlanderSE: 'ProviderNortlander',
  PrimoToursDK: 'ProviderPrimotours',
  SnowToursDK: 'ProviderSnowtours',
  SunCharterDK: 'ProviderSuncharter',
};

export interface ProviderAnimationProps {
  /** Whether the animation is hovered */
  isHovered?: boolean;
  /** Indicates the provider name of the offer */
  providerCode?: BrandTag;
}

const ProviderAnimation = ({
  isHovered,
  providerCode,
}: ProviderAnimationProps) => {
  const name = providerCode ? BRAND_TAG_ANIMATION_MAP[providerCode] : undefined;

  if (!name) {
    return null;
  }

  return <RiveAnimation isHovered={isHovered} name={name} />;
};

ProviderAnimation.displayName = 'ProviderAnimation';

export default ProviderAnimation;
